import React from 'react';
import { useLoaderData, useNavigate, useNavigation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutFrom from './CheckoutFrom';
import Loading from '../../Home/Share/Loading/Loading';



const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);


const Payment = () => {
    const bookings = useLoaderData();
    const navigation = useNavigation();


    const { treatment, price, slot, selectedDate } = bookings;
    if (navigation.state === 'loading') {
        return <Loading></Loading>
    }

    return (
        <div>
            <h1 className='text-3xl'>Payment For : {treatment}</h1>
            <p className='text-xl'>Please Pay :$ <strong>{price}</strong> for Your appointment at {selectedDate} on {slot}.</p>
            <div className='w-96 my-12'>
                <Elements stripe={stripePromise}>
                    <CheckoutFrom
                        bookings={bookings}

                    />
                </Elements>
            </div>
        </div>
    );
};

export default Payment;